import { render, staticRenderFns } from "./_base-text-input.vue?vue&type=template&id=2af8ab53&scoped=true&"
import script from "./_base-text-input.vue?vue&type=script&lang=js&"
export * from "./_base-text-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8ab53",
  null
  
)

export default component.exports